// Google Analytics 4 helpers.
// gtag.js is loaded once in public/index.html (G-PRVQ6QP9F9), so we only
// forward events to window.gtag here - no second initialisation.

const gtag = (...args) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  try {
    window.gtag(...args);
  } catch (error) {
    console.error('GA event failed:', error);
  }
};

export const trackPageView = (path, title) => {
  gtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
  });
};

export const trackEvent = (name, params = {}) => {
  gtag('event', name, params);
};

export const trackFormSubmission = (formName) => {
  trackEvent('form_submit_attempt', { form_name: formName });
};

// GA4 recommended event - mark as a Key Event in GA4 and import it into
// Google Ads as the primary conversion action.
export const trackLeadGenerated = (source) => {
  trackEvent('generate_lead', { form_name: source, currency: 'AUD', value: 1 });
};

export const trackAgentApplication = () => {
  trackEvent('sign_up', { method: 'agent_application' });
};

export const trackButtonClick = (buttonName, section) => {
  trackEvent('cta_click', { button_name: buttonName, section: section || 'general' });
};
